<template>
  <div class="ac-scrim" data-test="pfe-confirm-scrim">
    <div class="ac" role="dialog" aria-modal="true" aria-label="Turn on auto-send" data-test="pfe-confirm" @keydown.esc.stop="$emit('cancel')">
      <div class="ac-body">
        <div class="ac-title">Turn on auto-send?</div>
        <div class="ac-lead" data-test="pfe-confirm-groups"><strong>{{ groupsText }}</strong> will send post-ops.</div>
        <div class="ac-tiles">
          <div class="ac-tile"><div class="ac-tile-label">Text</div><div class="ac-tile-n" data-test="pfe-confirm-text">{{ rowsText(analysis.smsRows) }}</div></div>
          <div class="ac-tile"><div class="ac-tile-label">Email</div><div class="ac-tile-n" data-test="pfe-confirm-email">{{ rowsText(analysis.emailRows) }}</div></div>
        </div>
        <div class="ac-when" data-test="pfe-confirm-when">
          <i class="fa fa-clock-o" aria-hidden="true"></i><span>{{ whenText }}</span>
        </div>
        <div v-if="analysis.overlapRows.length" class="ac-double" data-test="pfe-confirm-double">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          <span><strong>{{ analysis.overlapHead }}</strong> {{ analysis.overlapBody }}</span>
        </div>
        <div class="ac-fine">Only procedures completed after you turn this on are sent.</div>
      </div>
      <div class="ac-foot">
        <button ref="cancel" type="button" class="ac-btn" data-test="pfe-confirm-cancel" @click="$emit('cancel')">Cancel</button>
        <button type="button" class="ac-btn ac-btn--primary" :disabled="busy" data-test="pfe-confirm-ok" @click="$emit('confirm')">Turn on auto-send</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * "Turn on auto-send?" — the counts come from the SAME analysis the switch's block rule uses, so the dialog can never promise
 * rows the server would refuse. Confirming saves the rows (if changed) and then `enabled:'TRUE'`; the editor shows the
 * server's liveSince.
 */
export default {
  name: 'PfeAutoSendConfirm',
  props: {
    analysis: { type: Object, required: true },
    whenText: { type: String, default: '' },
    busy: { type: Boolean, default: false },
  },
  computed: {
    groupsText() {
      const n = this.analysis.sending;
      return `${n} procedure ${n === 1 ? 'group' : 'groups'}`;
    },
  },
  mounted() {
    this.$nextTick(() => { if (this.$refs.cancel) this.$refs.cancel.focus(); });
  },
  methods: {
    rowsText(n) { return `${n} ${n === 1 ? 'row' : 'rows'}`; },
  },
};
</script>

<style lang="scss" scoped>
@import './editor';

.ac-scrim {
  position: absolute;
  inset: 0;
  z-index: 50;
  background: rgba(12, 15, 14, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.ac {
  width: 520px;
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  background: $pp-surface;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(12, 15, 14, 0.28);
}
.ac-body { padding: 24px 26px 6px; display: flex; flex-direction: column; gap: 14px; }
.ac-title { font-family: $pp-font-display; font-weight: 800; font-size: 22px; letter-spacing: -0.02em; }
.ac-lead { font-size: 15px; line-height: 1.5; }
.ac-tiles { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
.ac-tile { padding: 12px 14px; border-radius: 12px; background: $pfe-neutral-25; border: 1px solid $pp-border; }
.ac-tile-label { font-size: 12px; font-weight: 700; color: $pfe-neutral-500; }
.ac-tile-n { margin-top: 2px; font-size: 20px; font-weight: 800; font-variant-numeric: tabular-nums; }
.ac-when {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: $pfe-neutral-800;

  i { margin-top: 3px; color: $pfe-neutral-500; }
}
.ac-double {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: $pp-amber-subtle;
  border: 1px solid #f3cf8e;
  font-size: 13.5px;
  line-height: 1.5;
  color: $pfe-neutral-800;

  i { margin-top: 3px; color: #b77400; }
}
.ac-fine { font-size: 13px; color: $pfe-neutral-500; }
.ac-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 18px 26px 22px; }
.ac-btn {
  @include pfe-button(secondary);
  height: 40px;

  &--primary { @include pfe-button(primary); height: 40px; }
}
</style>
